var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-file',_vm._g(_vm._b({staticClass:"form-control",attrs:{"id":_vm.fieldId},on:{"input":function($event){return _vm.$emit('update', $event)}}},'b-form-file',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }